import React, { useState, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import { binService } from "/app/src/services";
import { Bin as BinType } from "/app/src/models";
import Search from "../search";
import { useTranslation } from "react-i18next";
import { createColumnHelper } from "@tanstack/react-table";
import Table from "/app/src/components/generic/tables/table";
import { useSortUpgrade } from "/app/src/hooks/useSortUpgrade";
import usePaginatedData from "/app/src/hooks/usePaginatedData";
export default function Bins() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const columnHelper = createColumnHelper<BinType>();
  const columns = useMemo(
    () => [
      columnHelper.accessor("name", {
        id: "name",
        cell: (info) => info.getValue(),
        header: () => t("translation:name"),
      }),
      columnHelper.accessor("width", {
        id: "width",
        cell: (info) => info.getValue(),
        header: () => t("translation:width"),
      }),
      columnHelper.accessor("height", {
        id: "height",
        cell: (info) => info.getValue(),
        header: () => t("translation:height"),
      }),
      columnHelper.accessor("depth", {
        id: "depth",
        cell: (info) => info.getValue(),
        header: () => t("translation:depth"),
      }),
    ],
    [columnHelper, t],
  );

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [sort, setSort] = useSortUpgrade([]);
  const [searchString, setSearchString] = useState("");

  const goToBin = useCallback(
    (binId: number) => {
      navigate(`/explorer/bins/${binId}`);
    },
    [navigate],
  );

  const {
    data: bins,
    count,
    isFetching,
  } = usePaginatedData<BinType>({
    queryKey: ["bins"],
    searchString,
    page,
    pageSize,
    sort,
    service: binService,
  });

  return (
    <div className="explorer">
      <Helmet>
        <title>{t("translation:bins")} - ItemPath</title>
      </Helmet>
      <div className="search box">
        <Search setSearchString={setSearchString} />
      </div>
      <Table
        loading={isFetching}
        rows={bins}
        tableColumns={columns}
        length={count}
        sort={sort}
        setSort={setSort}
        paginationEnabled={{
          currentPage: page,
          pageSize,
          setPage,
          setPageSize,
        }}
        enableRowSelection
        rowClicked={goToBin}
        emptyText={t("translation:no_bins")}
      />
    </div>
  );
}
